export default __webpack_public_path__ + "static/media/security.cbae9db1.svg";